import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  OnInit
} from "@angular/core";

const ROTATE_EVERY_MS = 2800;

@Component({
  selector: "app-rotating-title",
  templateUrl: "./rotating-title.component.html",
  styleUrls: ["./rotating-title.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RotatingTitleComponent implements OnInit, OnDestroy {
  readonly messages = [
    "comparison.progress.title1",
    "comparison.progress.title2",
    "comparison.progress.title3",
    "comparison.progress.title4"
  ];
  activeIndex = 0;
  previousIndex: number | null = null;

  private timer: ReturnType<typeof setInterval>;

  constructor(private zone: NgZone, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      this.timer = setInterval(() => {
        this.previousIndex = this.activeIndex;
        this.activeIndex = (this.activeIndex + 1) % this.messages.length;
        this.cd.detectChanges();
      }, ROTATE_EVERY_MS);
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }
}
